import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function RoutedThroughAnnouncement({ node }) {
    return (_jsxs(_Fragment, { children: ["Audio message \u00B7 ", _jsx("strong", { children: node.label }), " is played"] }));
}
